module.exports = __webpack_public_path__ + "img/france-diabetes-mellitus-female.4e5afaaa.png";